import { createSlice } from '@reduxjs/toolkit';
export const SLOTS_LAYOUT_KEY = 'boushar.slots.layout.settings';
const MODES = ['auto', 'portrait', 'landscape'];
export const loadSlotsLayoutSettings = () => {
    try {
        const stored = localStorage.getItem(SLOTS_LAYOUT_KEY);
        if (stored != undefined) {
            const parsed = JSON.parse(stored);
            if (MODES.includes(parsed === null || parsed === void 0 ? void 0 : parsed.mode)) {
                return parsed;
            }
        }
    }
    catch (error) {
        console.error('Failed to read slots layout settings from localStorage:', error);
    }
    return { mode: 'auto' }; // Default: automatic orientation/width detection
};
const saveSlotsLayoutSettings = (state) => {
    try {
        localStorage.setItem(SLOTS_LAYOUT_KEY, JSON.stringify(state));
    }
    catch (error) {
        console.error('Failed to save slots layout settings to localStorage:', error);
    }
};
const slotsLayoutSlice = createSlice({
    name: 'slotsLayout',
    initialState: loadSlotsLayoutSettings,
    reducers: {
        setSlotsLayoutMode: (state, action) => {
            state.mode = action.payload;
            saveSlotsLayoutSettings(state);
        }
    }
});
export const { setSlotsLayoutMode } = slotsLayoutSlice.actions;
export default slotsLayoutSlice;
